import Phaser from 'phaser';
import EDC from '../../../shared/globals';

EDC.Games.MatchingChests.Clocks.Digital = function (scene) {
  this.scene = scene;
  this.bg = null;
  this.hourDigits = [
    {
      position: new Phaser.Geom.Point(-110, 0),
      sprite: null,
    },
    {
      position: new Phaser.Geom.Point(-45, 0),
      sprite: null,
    },
  ];
  this.minuteDigits = [
    {
      position: new Phaser.Geom.Point(45, 0),
      sprite: null,
    },
    {
      position: new Phaser.Geom.Point(110, 0),
      sprite: null,
    },
  ];
  this.time = {
    hours: null,
    minutes: null,
  };
  this.container = null;
};

EDC.Games.MatchingChests.Clocks.Digital.prototype.create = function () {
  this.container = this.scene.add.container(0, 0);
  this.bg = this.scene.add.sprite(0, 0, 'clock-digital-bg');
  this.setTime(1, 5);
  this.container.add(this.bg);
};

EDC.Games.MatchingChests.Clocks.Digital.prototype.destroyDigital = function () {
  this.container.destroy();
  this.bg.destroy();
};

EDC.Games.MatchingChests.Clocks.Digital.prototype.place = function (x, y) {
  this.container.setPosition(x, y);
};

EDC.Games.MatchingChests.Clocks.Digital.prototype.setTime = function (hours, minutes) {
  const hourChars = this.getDigits(hours);
  this.createDigits(this.hourDigits, hourChars);

  const minuteChars = this.getDigits(minutes);
  this.createDigits(this.minuteDigits, minuteChars);

  this.time.hours = hours;
  this.time.minutes = minutes;
};

EDC.Games.MatchingChests.Clocks.Digital.prototype.createDigits = function (target, chars) {
  if (chars.length !== target.length) {
    console.error('Digits count != 2');
  }
  for (let i = 0; i < target.length; i++) {
    const pos = target[i].position;
    target[i].sprite = this.scene.add.sprite(pos.x, pos.y, `clock-digital-${chars[i]}`);
    this.container.add(target[i].sprite);
  }
};

EDC.Games.MatchingChests.Clocks.Digital.prototype.getDigits = function (value) {
  const res = [];
  let str = value.toString();
  if (str.length < 2) {
    str = `0${str}`;
  }
  for (let i = 0; i < str.length; i++) {
    res.push(str[i]);
  }
  return res;
};

export default EDC.Games.MatchingChests.Clocks.Digital;
